import { render, staticRenderFns } from "./DescriptionButton.vue?vue&type=template&id=338f82d0&scoped=true&lang=pug&"
import script from "./DescriptionButton.vue?vue&type=script&lang=js&"
export * from "./DescriptionButton.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionButton.vue?vue&type=style&index=0&id=338f82d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f82d0",
  null
  
)

export default component.exports